import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ResumeFlow = 'hormigon' | 'cemento';

@Injectable({ providedIn: 'root' })
export class ResumeContextService {
  private readonly flowSource = new BehaviorSubject<ResumeFlow | null>(null);
  readonly flow$ = this.flowSource.asObservable();
  get flow(): ResumeFlow | null { return this.flowSource.value; }
  setFlow(flow: ResumeFlow | null): void { this.flowSource.next(flow); }
}
